import { render } from "./BaseCustomDropdown.vue?vue&type=template&id=55c6e263&scoped=true&ts=true"
import script from "./BaseCustomDropdown.vue?vue&type=script&lang=ts"
export * from "./BaseCustomDropdown.vue?vue&type=script&lang=ts"

import "./BaseCustomDropdown.vue?vue&type=style&index=0&id=55c6e263&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c6e263"]])

export default __exports__